import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgEqual = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 9h14M5 15h14" />
  </svg>
)
const ForwardRef = forwardRef(SvgEqual)
export default ForwardRef
